import {useCallback, useContext} from 'react';
import {useTranslation} from 'react-i18next';
import {Redirect} from 'react-router-dom';

import {UserContext} from 'context';
import {useObservable} from 'hooks';
import {TRANSLATION_KEYS} from 'locale';
import {ErrorPage} from 'pages/Common';
import {socketStore} from 'services';

const T_KEYS = TRANSLATION_KEYS.COMMON.MESSAGES.CONNECTION;

export const ServerConnectionError: React.FC = () => {
    const {t} = useTranslation();
    const {socket} = useContext(UserContext);
    const {connected: socketConnected} = useObservable(socketStore);

    const handleOpenDefaultPage = useCallback(() => {
        socket.connect();
    }, [socket]);

    if (socketConnected) {
        return <Redirect to='/' />;
    }

    return (
        <ErrorPage message={t(T_KEYS.FAILED)} showOpenDefaultPageButton handleOpenDefaultPage={handleOpenDefaultPage}>
            <div className='tw-text-center tw-ts-h5'>
                {t(T_KEYS.REFRESH_REQUIRED)}
            </div>
        </ErrorPage>
    );
};
